import logo from "@/assets/Images";
import { ArrowRightStartOnRectangleIcon } from "@heroicons/react/24/solid";
import { ModalWrapper, Image, ButtonBase } from "@repo/ui/index.tsx";
import React from "react";

type TLogoutConfirmModal = {
  isOpen: boolean;
  handleCloseModal: () => void;
  logoutHandler: () => void;
  className?: string;
};

const LogoutConfirmModal: React.FC<TLogoutConfirmModal> = ({
  isOpen,
  handleCloseModal,
  logoutHandler,
  className = "w-80",
}) => {
  return (
    <ModalWrapper
      isOpen={isOpen}
      handleCloseModal={handleCloseModal}
      title="Logout"
    >
      <div className={`flex flex-col items-center gap-4 ${className}`}>
        <section className="relative">
          <Image
            src={logo.Logout}
            className=" w-32 object-contain border-b border-extraLightGray"
          />
        </section>
        <div className="text-center">
          <p className="text-lg font-bold">
            <span className="">Comeback Soon</span>
          </p>
          <p className="text-sm mt-2">Are you sure you want to logout?</p>
        </div>
        <div className="flex flex-row gap-2 w-full mt-4">
          <ButtonBase
            type="button"
            buttonType="secondary"
            text="Cancel"
            className="h-10 w-full text-body border-2 border-gray-300"
            onClick={handleCloseModal}
          />
          <ButtonBase
            text="Yes, Logout"
            buttonType="tertiary"
            type="submit"
            className={`h-10 w-full text-white bg-error`}
            icon={<ArrowRightStartOnRectangleIcon className="size-5" />}
            onClick={logoutHandler}
          />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default LogoutConfirmModal;
